import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_CIRCLE_POST_DETAIL_CONTENT,
  FETCH_CIRCLE_POST_DETAIL_CONTENT_SUCCESS,
  FETCH_CIRCLE_POST_DETAIL_CONTENT_FAILED,
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

export const fetchCirclePostDetail = (post) => (dispatch) => {
  dispatch({
    type: FETCH_CIRCLE_POST_DETAIL_CONTENT,
    payload: null,
  });
  const formData = {
    ...post,
    token: getAuthUserToken(),
  };
  http
    .post("circle-detail", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      dispatch({
        type: FETCH_CIRCLE_POST_DETAIL_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CIRCLE_POST_DETAIL_CONTENT_FAILED,
        payload: error,
      });
    });
};
